
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Search, Calendar } from 'lucide-react';

interface ClientsSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
  dateFromFilter: string;
  onDateFromFilterChange: (value: string) => void;
  dateToFilter: string;
  onDateToFilterChange: (value: string) => void;
}

const ClientsSearch: React.FC<ClientsSearchProps> = ({ 
  searchTerm, 
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  dateFromFilter,
  onDateFromFilterChange,
  dateToFilter,
  onDateToFilterChange
}) => {
  return (
    <Card className="glass-card">
      <CardContent className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <div className="relative lg:col-span-2">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary-500 w-4 h-4" />
            <Input
              placeholder="Buscar por nome, CNPJ ou nome fantasia..."
              value={searchTerm}
              onChange={(e) => {
                console.log('🔍 [ClientsSearch] Input onChange chamado:', e.target.value);
                onSearchChange(e.target.value);
              }}
              onFocus={(e) => {
                console.log('🔍 [ClientsSearch] Input onFocus chamado');
              }}
              onKeyDown={(e) => {
                console.log('🔍 [ClientsSearch] Input onKeyDown chamado:', e.key);
              }}
              className="pl-10 border-gray-200 focus:border-primary-400 focus:ring-primary-400"
            />
          </div>
          
          <div>
            <Select value={statusFilter} onValueChange={onStatusFilterChange}>
              <SelectTrigger className="border-gray-200 focus:border-primary-400">
                <SelectValue placeholder="Status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todos</SelectItem>
                <SelectItem value="active">Ativos</SelectItem>
                <SelectItem value="inactive">Inativos</SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          <div className="relative">
            <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary-500 w-4 h-4" />
            <Input
              type="date"
              placeholder="Data início"
              value={dateFromFilter}
              onChange={(e) => onDateFromFilterChange(e.target.value)}
              className="pl-10 border-gray-200 focus:border-primary-400 focus:ring-primary-400"
            />
          </div>
          
          <div className="relative">
            <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary-500 w-4 h-4" />
            <Input
              type="date"
              placeholder="Data fim"
              value={dateToFilter}
              onChange={(e) => onDateToFilterChange(e.target.value)}
              className="pl-10 border-gray-200 focus:border-primary-400 focus:ring-primary-400"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ClientsSearch;
